<app-header *ngIf="!hideHeader"></app-header>
<app-announcement-banner
  [ngClass]="{'mobile-hidden': announcementBannerService.hideNotificationBannerOnMobile| async, 'desktop-hidden': announcementBannerService.hideNotificationBannerOnDesktop | async}"></app-announcement-banner>
<div class="gateway-container" role="main">
  <router-outlet></router-outlet>
</div>
<app-footer *ngIf="!hideFooter"></app-footer>
